module.exports = __webpack_public_path__ + "8931cc2423c52996c54806752df048ee.png";